import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70ef5a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-columns-style" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "flex-end mt_16" }
const _hoisted_4 = { class: "flex-center" }

import { ref, toRaw, computed, onMounted } from 'vue'
// 先注释拖拽功能，说不定后面需要这个功能
// import { vDragable } from 'element-plus-table-dragable'
import { ElMessage, ElTable } from 'element-plus'
import { t, lang } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: {
  productColumns: {
    type: Array,
    default: () => []
  },
  selectedColumns: {
    type: Array,
    default: () => []
  }
},
  emits: ['handleOk', 'cancel'],
  setup(__props, { emit }) {

const props = __props
const multipleTableRef = ref<InstanceType<typeof ElTable>>()
// 先注释拖拽功能，说不定后面需要这个功能
// const isSetInitTableColumns = ref(false)

// productColumns

/** 判断是否可以进行勾选 */
const changeSelectable = (item:any) => {
  //   不可取消勾选
  if (item.ununcheck) {
    return false
  }
  return true
}
const tableData:any = ref([])
/** 初始化表格筛选项 */
const initTableColumns = (selectedColumns) => {
  const selectedColumnsArr = selectedColumns.map(item => item.prop)
  const newArr = props.productColumns.map((item, index) => {
    const _item:any = item
    let detail = ''
    if (_item.children && _item.children.length) {
      // 累加
      detail = _item.children.reduce(function (prev, cur, index) {
        const space = index === _item.children.length - 1 ? '' : '、'
        return prev + cur.label + space
      }, '')
    }
    let selected = false
    if (selectedColumnsArr.includes(_item.prop)) {
      selected = true
    }
    // 不可取消勾选
    if (_item.ununcheck) {
      selected = true
    }

    return { ..._item, sort: index, selected, children: [], detail }
  })
  //   循环，将table对应的项选中
  newArr.filter(item => item.selected).forEach((item) => {
    multipleTableRef.value!.toggleRowSelection(item, true)
  })
  tableData.value = newArr
  multipleSelection.value = newArr
}
// 先注释拖拽功能，说不定后面需要这个功能
/** 表格恢复为初始态 */
// const handleChangeSetInitTableColumns = (val) => {
//   isSetInitTableColumns.value = val
//   if (val) {
//     initTableColumns(props.productColumns)
//   }
// }
onMounted(() => {
  initTableColumns(props.selectedColumns)
})

const getRowKey = (val) => {
  return val.prop
}

const multipleSelection:any = ref(tableData)



/** 勾选 */
const handleSelectionChange = (val) => {
  const _multipleSelection = tableData.value.map((item) => {
    const index = val.findIndex(sonItem => sonItem.prop === item.prop)
    if (index !== -1) {
      return { ...item, selected: true }
    }
    return { ...item, selected: false }
  })
  multipleSelection.value = _multipleSelection
}
/** 确认 */
const handleClick = () => {
  // 过滤下，只需要选中的
  const data = multipleSelection.value.filter((item) => item.selected)
  //   选中的去匹配，将children加进去
  const _data = data.map((item) => {
    const _item:any = props.productColumns.find((sonItem) => sonItem.prop === item.prop)
    if (_item.children) {
      return { ...item, children: _item.children }
    }
    return { ...item }
  })
  if (_data.length && _data.length === props.productColumns.length) {
    // 表格已恢复为初始状态
    ElMessage.success(
      t('表格已恢复为初始状态')
    )
  }

  emit('handleOk', _data)
}
// 先注释，说不定后面需要这个功能
// const dragOptions = [
//   {
//     selector: 'tbody', // add drag support for row
//     option: { // sortablejs's option
//       animation: 150,
//       onEnd: (evt) => {
// const cloneArr = [...toRaw(multipleSelection.value)]
// const _cloneArr = cloneArr.sort((a, b) => a.sort - b.sort)
// // 差值
// const diffVal = evt.oldIndex - evt.newIndex > 0 ? evt.oldIndex - evt.newIndex : evt.newIndex - evt.oldIndex
// if (diffVal <= 0) return
// // 当只移动一位
// if (diffVal === 1) {
//   _cloneArr[evt.oldIndex].sort = evt.newIndex
//   _cloneArr[evt.newIndex].sort = evt.oldIndex
//   multipleSelection.value = _cloneArr.sort((a, b) => a.sort - b.sort)
//   return
// }
// // 当上往下移动
// if (evt.newIndex > evt.oldIndex) {
//   const value = _cloneArr[evt.newIndex]
//   _cloneArr[evt.oldIndex].sort = evt.newIndex
//   const data = _cloneArr.sort((a, b) => a.sort - b.sort).map((item) => {
//     return { ...item, sort: item.sort - 1 }
//   })
//   const _data = data.map((item, index) => {
//     if (index >= evt.newIndex - 1 && item.prop !== value.prop) {
//       return { ...item, sort: item.sort + 1 }
//     }
//     return item
//   })
//   multipleSelection.value = _data.sort((a, b) => a.sort - b.sort)
//   return
// }
// // 当下往上移动
// const _value = _cloneArr[evt.oldIndex]
// _cloneArr[evt.oldIndex].sort = evt.newIndex
// const data = _cloneArr.sort((a, b) => a.sort - b.sort)
// const _data = data.map((item, index) => {
//   if (item.prop === _value.prop) {
//     return { ...item }
//   }
//   if (index < evt.newIndex) {
//     return { ...item }
//   }
//   return { ...item, sort: item.sort + 1 }
// })
// multipleSelection.value = _data.sort((a, b) => a.sort - b.sort)
//       }
//     }
//   }
// ]
const cancel = () => {
  emit('cancel')
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('表格筛选')), 1),
    _createElementVNode("div", null, [
      _createVNode(_unref(ElTable), {
        height: "400",
        ref: (_value, _refs) => {
          _refs['multipleTableRef'] = _value
          multipleTableRef.value = _value
        },
        onSelectionChange: handleSelectionChange,
        data: tableData.value,
        rowKey: (val)=>getRowKey(val),
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55",
            "reserve-selection": true,
            selectable: changeSelectable,
            fixed: ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "label",
            label: _unref(t)('标题1'),
            noLazyChildren: "",
            width: "120"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "detail",
            width: "180",
            label: _unref(t)('明细1')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "rowKey"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "default mr_8",
          onClick: cancel
        }, _toDisplayString(_unref(t)('取消')), 1),
        _createElementVNode("div", {
          class: "default primay",
          onClick: handleClick
        }, _toDisplayString(_unref(t)('确定')), 1)
      ])
    ])
  ]))
}
}

})